import { Pedometer } from 'expo-sensors';
// TODO: Unify the Pedometer module across platforms so we can export it normally

export default Pedometer;
